import React, { Component } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

import './style.scss';
import PopupImage from './PopupImage';

const Quill = ReactQuill.Quill;
const BlockEmbed = Quill.import('blots/block/embed');
const Inline = Quill.import('blots/inline');
class WordBlot extends BlockEmbed {
  static create(data) {
    let node = super.create();
    node.setAttribute('href', data.url);
    node.setAttribute('class', 'word-item');
    node.setAttribute('target', '_blank');
    node.setAttribute('name', data.filename || 'Unknown File'); // Сохраняем имя файла в атрибуте 'name'
    node.innerHTML = data.filename || 'Unknown File'; // Используем название файла или 'Unknown File', если название не предоставлено

    return node;
  }

  static value(node) {
    return {
      url: node.getAttribute('href'),
      filename: node.getAttribute('name') || node.innerText, // Если внутренний текст отсутствует, то возвращаем значение из атрибута 'name'
    };
  }
}

class DividerBlot extends BlockEmbed {
  static create(url) {
    let node = super.create();
    node.setAttribute('controls', '');
    node.setAttribute('class', 'line-row-homework-c');
    return node;
  }
}

class AudioBlot extends BlockEmbed {
  static create(url) {
    let node = super.create();
    node.setAttribute('src', url);
    node.setAttribute('controls', '');
    node.setAttribute('class', 'audio-item');
    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}

class ImageBlot extends BlockEmbed {
  static create(value) {
    let node = super.create();
    node.setAttribute('alt', value.alt);
    node.setAttribute('src', value.url);
    node.setAttribute('class', 'image-item');
    return node;
  }
  static value(node) {
    return {
      alt: node.getAttribute('alt'),
      url: node.getAttribute('src'),
    };
  }
}

class LinkBlot extends Inline {
  static create(url) {
    const node = super.create();
    node.setAttribute('href', url);
    node.setAttribute('class', 'link-item');
    node.setAttribute('target', '_blank');
    node.setAttribute('contenteditable', 'false');
    return node;
  }

  static formats(node) {
    return node.getAttribute('href');
  }

  static value(node) {
    return node.getAttribute('href');
  }
}

class VideoBlot extends BlockEmbed {
  static create(url) {
    let node = super.create();
    node.setAttribute('src', url);
    node.setAttribute('controls', '');
    node.setAttribute('class', 'video-item');
    return node;
  }

  static value(node) {
    return node.getAttribute('src');
  }
}

class StudentHomeworkItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      homeWorkValue: '',
      contextObject: null,
      name: '',
      loading: false,
      content: '',
      message: '',
      deletedUrls: [],
      addedUrls: [],
      subject: '',
      subjects: [],
      isForNotebook: false,
      progressFilePost: 0,
      rowApdute: '',
      arrayFilesEditor: [],
      arrayFiles: [],
      readOnly: true,
      imageSrc: null,
    };

    this.context = React.createRef();
    this.setContext = this.setContext.bind(this);
    this.handleImage = this.handleImage.bind(this);
    this.handleVideo = this.handleVideo.bind(this);
    this.handleMusic = this.handleMusic.bind(this);
    this.handleNewPart = this.handleNewPart.bind(this);
    this.onSubjectChange = this.onSubjectChange.bind(this);
    this.handleImageClick = this.handleImageClick.bind(this);
    this.closeImagePopup = this.closeImagePopup.bind(this);
    this.handleLinkInsert = this.handleLinkInsert.bind(this);

    AudioBlot.blotName = 'audio';
    AudioBlot.tagName = 'audio';

    ImageBlot.blotName = 'img';
    ImageBlot.tagName = 'img';

    VideoBlot.blotName = 'video';
    VideoBlot.tagName = 'video';

    DividerBlot.blotName = 'divider';
    DividerBlot.tagName = 'hr';

    WordBlot.blotName = 'word';
    WordBlot.tagName = 'a';

    LinkBlot.blotName = 'link';
    LinkBlot.tagName = 'a';

    Quill.register(AudioBlot);
    Quill.register(DividerBlot);
    Quill.register(ImageBlot);
    Quill.register(VideoBlot);
    Quill.register('formats/word', WordBlot);
    Quill.register(LinkBlot);
  }

  componentDidMount() {
    this.setState({ content: this.props.content });

    if (this.quillRef) {
      this.quillRef.getEditor().root.addEventListener('click', this.handleImageClick);
    }
  }

  componentWillUnmount() {
    if (this.quillRef) {
      this.quillRef.getEditor().root.removeEventListener('click', this.handleImageClick);
    }
  }

  handleImageClick(e) {
    const image = e.target.closest('img');
    if (image) {
      this.setState({ imageSrc: image.src });
    }
  }

  closeImagePopup() {
    this.setState({ imageSrc: null });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.content !== this.props.content) {
      this.setState({ content: this.props.content });
    }
  }

  setContext(context) {
    this.setState({ contextObject: context }, () => {
      if (this.state.contextObject && this.state.contextObject.editor) {
        this.state.contextObject.editor.root.addEventListener('click', this.handleImageClick);
      }
    });
  }

  handleImage() {
    this.handleFile('image/*', 'image');
  }

  handleVideo() {
    this.handleFile('video/mp4,video/x-m4v,video/*', 'video');
  }

  handleMusic() {
    this.handleFile('audio/*', 'audio');
  }

  handleLinkInsert = url => {
    if (url) {
      let quill = this.state.contextObject.getEditor();
      let selection = quill.getSelection(true);

      if (selection) {
        const { index } = selection;

        if (text) {
          const linkAttributes = url;
          const spanNode = document.createElement('span');
          spanNode.innerText = text;
          spanNode.setAttribute('href', linkAttributes);
          spanNode.setAttribute('class', 'link-item');
          spanNode.setAttribute('target', '_blank');
          spanNode.setAttribute('contenteditable', 'false');
          spanNode.addEventListener('click', () => {
            window.open(linkAttributes, '_blank');
          });

          quill.insertEmbed(index, 'link', linkAttributes, Quill.sources.USER);
          quill.insertText(index + 1, '\uFEFF');
          quill.setSelection(index + 1, Quill.sources.SILENT);
          quill.clipboard.dangerouslyPasteHTML(index + 1, spanNode.outerHTML);
          quill.setSelection(index + 1 + spanNode.innerText.length, Quill.sources.SILENT);
        }
      }
    }
  };

  handleNewPart() {
    let quill = this.state.contextObject.getEditor();
    let range = quill.getSelection(true);
    quill.insertEmbed(range.index, 'divider', true, Quill.sources.USER);
    quill.setSelection(range.index + 2, Quill.sources.SILENT);
  }

  onSubjectChange = e => {
    let subject = e.target.selectedIndex == 0 ? null : e.target.value;
    this.setState({
      subject,
    });
  };

  render() {
    return this.state.loading ? (
      <span className="spinner-border spinner-border-sm"></span>
    ) : (
      <>
        <div className="editor-homework-page container">
          {this.props.checklist ? (
            <div>
              <ReactQuill
                ref={el => {
                  this.quillRef = el;
                }}
                modules={{
                  toolbar: false,
                }}
                value={this.state.content}
                theme="snow"
                readOnly={true}
              />
            </div>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: this.state.content }} />
          )}
        </div>
      </>
    );
  }
}

export default StudentHomeworkItem;
